import { Modal, ModalProps } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { MissingEInvoiceDetails } from '@features/invoices/types/missingEInvoiceDetails'

import { SendEInvoiceRequirementsModalBody } from './elements/SendEInvoiceRequirementsModalBody'
import { SendEInvoiceRequirementsModalFooter } from './elements/SendEInvoiceRequirementsModalFooter'

interface SendEInvoiceRequirementsModalProps extends ModalProps {
  cancelInvoiceModalId: string
  missingEInvoiceDetails?: MissingEInvoiceDetails
}

export const SendEInvoiceRequirementsModal = ({
  cancelInvoiceModalId,
  missingEInvoiceDetails,
  ...modalProps
}: SendEInvoiceRequirementsModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal {...modalProps} size="s">
      <Modal.Header title={t('external_invoices.send_e_invoice_requirements.modal.title')} />
      <SendEInvoiceRequirementsModalBody missingEInvoiceDetails={missingEInvoiceDetails} />
      <SendEInvoiceRequirementsModalFooter cancelInvoiceModalId={cancelInvoiceModalId} id={modalProps.id} />
    </Modal>
  )
}
